// vdv = very dark violet
// vdb = very dark blue

const themeThree = {
    backgrounds: {
        main: 'hsl(268, 75%, 9%)',
        toggle: 'hsl(268, 71%, 12%)',
        keypad: 'hsl(268, 71%, 12%)',
        screen: 'hsl(268, 71%, 12%)'
    },

    keys: {
        'dark-violet-bg': 'hsl(281, 89%, 26%)',
        'vivid-magenta-shadow': 'hsl(285, 91%, 52%)',
        'pure-cyan-bg-toggle': 'hsl(176, 100%, 44%)',
        'soft-cyan-shadow': 'hsl(177, 92%, 70%)',
        'vdv-bg': 'hsl(268, 47%, 21%)',
        'dark-magenta-shadow': 'hsl(290, 70%, 36%)'
    },

    text: {
        'light-yellow': 'hsl(52, 100%, 62%)',
        vdb: 'hsl(198, 20%, 13%)',
        white: 'hsl(0, 0%, 100%)'
    }
};

export default themeThree;
